import { fromSPC } from "./fromSPC.js";
/**
 * Creates a new Analysis from a PerkinElmer `.sp` file, binary (`PEPE`) or
 * ASCII (`PEDS`). The parser auto-detects the format, so this is the same as
 * `fromSPC`.
 * @param data - SP file content as ArrayBuffer, Buffer, or ArrayBufferView.
 * @param options - Options forwarded to spc-parser (e.g. `encoding`).
 * @returns A new Analysis instance with one spectrum per dataset in the file.
 */
export function fromSP(data, options = {}) {
    return fromSPC(data, options);
}
//# sourceMappingURL=fromSP.js.map